import challengesIcon from "../assets/exercise-types/challenges.png";
import kingIcon from "../assets/exercise-types/king.png";
import matchIcon from "../assets/exercise-types/match.png";
import offTableIcon from "../assets/exercise-types/off-table.png";
import personalizedIcon from "../assets/exercise-types/personalized.png";
import serviceIcon from "../assets/exercise-types/service.png";
import shadowIcon from "../assets/exercise-types/shadow.png";
import stretchingIcon from "../assets/exercise-types/stretching.png";
import visualisationIcon from "../assets/exercise-types/visualisation.png";
import warmupIcon from "../assets/exercise-types/warmup.png";

function fold(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

const ICON_RULES = [
  { src: warmupIcon, test: /warmup|echauffement|aufwarmen|calentamiento/ },
  { src: stretchingIcon, test: /streaching|stretching|etirement|dehnung|estiramiento/ },
  { src: serviceIcon, test: /\bservice\b|aufschlag|servicio/ },
  { src: matchIcon, test: /\bmatch\b|\bspiel\b|partido/ },
  { src: shadowIcon, test: /shadow training|jeu a blanc|schattentraining|entrenamiento de sombras/ },
  { src: challengesIcon, test: /challenge|defis|herausforderung|desafio/ },
  { src: offTableIcon, test: /off-table|hors table|fuera de la mesa/ },
  { src: kingIcon, test: /king of the table|montee de table|konig des tisches|rey de la mesa/ },
  { src: visualisationIcon, test: /visualisation|visualization|visualisierung|visualizacion/ },
  { src: personalizedIcon, test: /personalized|personnali[sz]e|personnalise|personalisiert|personalizado/ },
];

function labelsOf(typeOrName) {
  if (typeOrName && typeof typeOrName === "object") {
    return [
      typeOrName.type_name_en,
      typeOrName.type_name_fr,
      typeOrName.type_name_de,
      typeOrName.type_name_es,
      typeOrName.type,
      typeOrName.name,
      typeOrName.label,
    ].filter((value) => value != null && String(value).trim());
  }
  return typeOrName ? [typeOrName] : [];
}

/** Icon for an exercise type, or null when this type has no dedicated mark. */
export function exerciseTypeIconSrc(typeOrName) {
  const blob = fold(labelsOf(typeOrName).join(" "));
  if (!blob) return null;
  const match = ICON_RULES.find((rule) => rule.test.test(blob));
  return match ? match.src : null;
}
